/**
 * Classe que gerencia os eventos de tela do SmartGeocode
 *
 * @author: Adalto Junior adaltojunior@sagaranatech.com DATE: 30/01/2013
 * @version: 1.0
 *
 */

App.Views.SmartGeocode = {

    buildFieldsFilter: function () {
        var filter = new Greenmile.SmartGeocode.Filter();
        App.Forms.SmartGeocode.filterBuilder = filter;
        return filter.render();

    },

    removeGridActions: function () {

        var gridActions = document.querySelector('#SmartGeocode .gridActions .actions');
        var customizeColumns = gridActions.querySelectorAll('.gridActionDiv');
        var popupCustomizeColumns = gridActions.querySelector(".MonetUIGridActionsButton");

        if (customizeColumns.length) {

            for (var i = 0; i < customizeColumns.length; i++) {
                var parent = customizeColumns[i].parentNode;

                parent.removeChild(customizeColumns[i]);

            }

        }

        if (popupCustomizeColumns) {

            var customParent = popupCustomizeColumns.parentNode;

            customParent.removeChild(popupCustomizeColumns);

        }

    },

    showGrid: function () {

        var grid = new Greenmile.SmartGeocode.Grid();
        var dataMapper = new Monet.Builder.DataMapper();

        var callback = function (context) {

            return function () {

                context.removeGridActions();
                grid.show();


            };

        }(this);

        dataMapper.setEntity('SmartGeocode');
        dataMapper.build(callback);

    },

    showMapAndDetailSmartGeocode: function (data) {

        var location = data.location;
        var detailSmartGeocode = new Greenmile.SmartGeocode.Map(location.id);
        var mapa = detailSmartGeocode.createMap();
        var listPosition = data.positionList;

        detailSmartGeocode.addMarkerListPositions(listPosition, mapa, location);
        detailSmartGeocode.addMarkerActualPosition(location, mapa);

        detailSmartGeocode.addEventListener();

        var selector = "#SmartGeocode #mapToolbar";
        var maps = mapa;
        var map_base = Greenmile.SmartGeocode.mapBaseLayer;

        Greenmile.SmartGeocode.map = maps;

        var options = {
            screenRoute: {
                mapBaseLayer: map_base
            }
        };
        var helper = new Monet.UI.Help('SmartGeocodeDetail', Monet.I18n.getResourcesByKey('Greenmile.SmartGeocode.list'));
        var toolbar = new Greenmile.Toolbar.Map(maps, selector, options, helper);

        toolbar.enable([
            toolbar.actions.searchAddressOnMap,
            toolbar.actions.points,
            toolbar.actions.street,
            toolbar.actions.zoom,
            toolbar.actions.source,
            toolbar.actions.fitToMarkers
        ]);

        toolbar.render();

        setTimeout( function(){
          new Greenmile.Components.AlertModal('SmartGeocode.user.must.select')
            .show();
        }, 500);

    }
};
